import { apiFetch } from './apiClient';



function qs(params = {}) {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') p.set(k, v);
  });
  const s = p.toString();
  return s ? `?${s}` : '';
}

export const buscarResumoRotinas = () => apiFetch('/rotinas/resumo');
export const sincronizarNibo = () => apiFetch('/rotinas/sincronizar', { method: 'POST' });

export const listarClientesNibo = (params) => apiFetch(`/rotinas/clientes${qs(params)}`);
export const buscarClienteNiboDetalhe = (id) => apiFetch(`/rotinas/clientes/${id}`);

export const listarObrigacoesNibo = (params) => apiFetch(`/rotinas/obrigacoes${qs(params)}`);
export const listarUsuariosNiboAPI = (params) => apiFetch(`/rotinas/usuarios${qs(params)}`);
export const atualizarStatusUsuarioNibo = (id, ativo) => apiFetch(`/rotinas/usuarios/${id}/status`, { method: 'PUT', body: JSON.stringify({ ativo }) });
export const listarDepartamentosNiboAPI = () => apiFetch('/rotinas/departamentos');
export const listarClientesDaObrigacao = (id, params) => apiFetch(`/rotinas/obrigacoes/${id}/clientes${qs(params)}`);
export const vincularClientesObrigacaoNibo = (id, dados) => apiFetch(`/rotinas/obrigacoes/${id}/clientes`, {
  method: 'POST',
  body: JSON.stringify(dados),
});
export const desvincularClienteObrigacaoNibo = (id, customerId) =>
  apiFetch(`/rotinas/obrigacoes/${id}/clientes/${customerId}`, { method: 'DELETE' });

export const listarTarefasNibo = (params) => apiFetch(`/rotinas/tarefas${qs(params)}`);
export const criarTarefaNibo = (payload) => apiFetch('/rotinas/tarefas', {
  method: 'POST',
  body: JSON.stringify(payload),
});

export const listarProtocolosNibo = (params) => apiFetch(`/rotinas/protocolos${qs(params)}`);
export const buscarDetalheProtocoloNibo = (customerId, filedId) =>
  apiFetch(`/rotinas/protocolos/${customerId}/${filedId}/detalhe`);

export const buscarCalendarioNibo = (params) => apiFetch(`/rotinas/calendario${qs(params)}`);
